export default {
  'meta': {
    'langName': 'ARABIC',
    'lang': 'العربية'
  },
  'title': 'إشعار بسحب منتج: سكوتر كهربائي SD500E أو MD500E من العلامة التجارية BTWIN',
  'description': 'مرحبًا،\n\nنشكركم على شرائكم سكوتر كهربائي من طراز SD 500E أو MD500E من العلامة التجارية BTWIN.\n\nونظرًا لأن سلامتكم هي أولويتنا القصوى، يرجى الاطلاع على المعلومات التالية:\n\nعلى الرغم من تطبيقنا لإجراءات صارمة في مراقبة الجودة، فقد رصدنا خللاً يؤثر على سلامة السكوتر الكهربائي SD500E و MD500E من العلامة التجارية BTWIN. حيث يمكن أن يؤدي الاستخدام المكثف إلى ظهور شق (شرخ) عند نقطة التقاء الهيكل وعامود المقود. هذا الخلل قد يتسبب في انكسار هذه الوصلة، مما يشكل خطر سقوط المستخدم.\n\nلذا، نرجو منكم الإجابة على الأسئلة التالية لنتمكن من تزويدكم بالحل المناسب لتأمين منتجكم وضمان سلامتكم.\n\nنعتذر عن هذا الإزعاج، ونشكركم على حسن ثقتكم بنا.\n\nديكاتلون (DECATHLON)',
  'emailConfirmation': {
    'title': 'بدايةً، يرجى تأكيد عنوان بريدكم الإلكتروني وبلد إقامتكم:'
  },
  'fields': {
    'country': 'دولة',
    'address': 'البريد الإلكتروني',
    'email': 'البريد الإلكتروني',
    'phonePrefix': 'رمز المنطقة لرقم الهاتف',
    'phone': 'رقم التليفون',
    'validations': {
      'phoneOrEmail': 'يرجى تقديم عنوان بريد إلكتروني أو رقم هاتف على الأقل',
      'email': 'يرجى إدخال عنوان بريد إلكتروني صالح',
      'phone': 'يرجى إدخال رقم هاتف صحيح',
      'selectAddress': 'يرجى اختيار عنوان كامل من القائمة (الرقم، الشارع، والمدينة).',
      'incompleteAddress': 'يجب أن يتضمن العنوان رقمًا واسم شارع ومدينة. أدخل على الأقل رقم الشارع واسم الشارع، ثم اختر اقتراحًا.'
    },
    'firstName': 'اسم',
    'lastName': 'الاسم الأول',
    'deliveryAddress': 'عنوان التوصيل',
    'additionalAddress': 'معلومات إضافية عن العنوان',
    'city': 'مدينة',
    'zip': 'رمز بريدي',
    'readConfirmation': 'لقد تحققت من بيانات الاتصال الخاصة بي، وقرأت المعلومات، وأوافق على الالتزام بها.',
    'choose': 'يختار',
    'required': 'هذه الخانة مطلوبه',
    'deliveryAddressHelp': 'أدخل رقم الشارع واسمه، ثم اختر عنوانًا كاملاً من القائمة.',
    'streetOnlyHint': 'أضف رقمًا'
  },
  'ownerCheck': {
    'title': 'هل ما زلتم تمتلكون سكوترًا كهربائيًا واحدًا أو أكثر من طراز SD500E و MD500E من العلامة التجارية BTWIN؟'
  },
  'yes': 'نعم',
  'no': 'لا',
  'ownerChanged': {
    'title': 'هل لديكم بيانات الاتصال بالمالك الحالي أو المالكين الحاليين؟',
    'confirmation': 'السيد/السيدة\n\nنشكركم على مشاركتكم في هذه المبادرة لتحسين الجودة.\n\nنعتذر عن أي إزعاج، ونشكركم على ثقتكم المستمرة.\n\nديكاتلون'
  },
  'recall': {
    'title': 'يرجى تحديد كمية الدراجات الكهربائية BTWIN SD500E و MD500E.',
    'descriptionSd500': 'الدراجات الكهربائية SD500E',
    'descriptionEmd500e': 'الدراجات الكهربائية MD500E',
    'modelNumberHelp': 'ستجد رقم الطراز (SD500E أو MD500E) أسفل السكوتر الخاص بك، كما هو موضح هنا.',
    'quantity': 'كمية',
    'confirmation': 'نشكرك على تعبئة هذا النموذج. تم تسجيل طلبك بنجاح.\n\nسنبلغك خلال ٢٠ يومًا بتاريخ إمكانية إجراء الإصلاح.\n\nنتمنى لك يومًا سعيدًا.\n\nديكاتلون'
  },
  'repair': {
    'title': 'إصلاح من قبلك',
    'description': 'نرجو منك التوقف عن استخدامه فورًا.\n\nسيتم إرسال طقم إصلاح وتعليمات إلى منزلك لتأمين سكوترك. هذا الطقم مجاني، وتجميعه سريع وسهل.\n\nبعد استلام معلوماتك، سنتواصل معك خلال ٢٠ يومًا لإبلاغك بموعد توفره. نؤكد لك أننا سنبذل قصارى جهدنا لتقليل هذه التأخيرات لضمان رضاك.',
    'videoLink': 'رابط فيديو التحرير',
    'kitLabel': 'طقم إصلاح كامل',
    'docLabel': 'تعليمات الإصلاح',
    'callToAction': 'انقر هنا للحصول على طقم الإصلاح مجاناً',
    'infoConfirmation': 'يرجى التحقق من معلوماتك',
    'validateConfirmation': 'للتحقق',
    'backConfirmation': 'خلف'
  },
  'repairRequest': {
    'title': 'يرجى إدخال المعلومات التالية لاستلام طقم الإصلاح الخاص بك:'
  },
  'form': {
    'submit': 'التالي'
  },
  'status': 'Translation validated by COUNTRY'
} as const
